import { useEffect } from "react";
import { useDistanceCulling } from "../src/hooks/useDistanceCulling";

export default function DistanceCulled({
  children,
  fallback = null,
  enabled = true,
  onVisibilityChange,
  ...options
}) {
  const result = useDistanceCulling({ ...options, enabled });

  useEffect(() => {
    if (typeof onVisibilityChange === "function") {
      onVisibilityChange(result);
    }
  }, [result.visible, result.distance, onVisibilityChange]);

  if (!enabled) {
    if (typeof children === "function") {
      return children({ visible: true, distance: result.distance });
    }
    return children;
  }

  if (!result.visible) {
    if (typeof fallback === "function") {
      return fallback(result);
    }
    return fallback;
  }

  if (typeof children === "function") {
    return children(result);
  }

  return children;
}
